






























import { Component, Vue, Prop } from "vue-property-decorator";

import IconExpandLess from "@/components/icons/IconExpandLess.vue";

import { OrderHeader } from "@/store/account/orders/types";
import { HeaderKeys } from "@/store/account/orders/enums";
import { SortDirections } from "@/store/catalog/enums";

@Component({ components: { IconExpandLess } })
export default class OrderTableHeaders extends Vue {
  tooltip = false;
  timer!: NodeJS.Timeout;

  @Prop({ type: Object, default: () => ({}) })
  readonly header!: OrderHeader;

  @Prop({ type: Boolean, default: true })
  readonly selectable!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly isSelected!: boolean;

  @Prop({ type: String, default: "" })
  readonly sortKey!: HeaderKeys;

  @Prop({ type: String, default: SortDirections.DESC })
  readonly sortDirection!: SortDirections;

  onEnter(key: HeaderKeys) {
    this.timer = setTimeout(() => {
      this.tooltip = !!this.header.tooltip;
    }, 500);
    this.$emit("highlight", { cell: key, state: true });
  }

  onLeave(key: HeaderKeys) {
    clearTimeout(this.timer);
    this.tooltip = false;
    this.$emit("highlight", { cell: key, state: false });
  }

  sort(key: HeaderKeys) {
    this.$emit("sort", {
      key,
      order: this.sortDirection || SortDirections.DESC,
    });
  }

  selectHandler(value: boolean) {
    this.$emit("select", { id: null, value });
  }
}
